<template>
  <div>
    <div v-show="!isInputMode">
      <span>{{ displayPrice }}</span>
      <button
        v-if="record['week' + weekIndex]"
        class="btn btn_sm bg_danger fr"
        @click="enterDeleteMode"
      >
        不可
      </button>
      <button
        class="btn btn_sm bg_blue fr"
        @click="enterUpdateMode"
      >
        更新
      </button>
    </div>
    <div v-show="isInputMode">
      <div v-show="isDeleteMode">
        <span>提供不可</span>
      </div>
      <div v-show="!isDeleteMode">
        <input
          v-model="inputPriceStr"
          type="text"
          class="form-control-sm"
          size="4"
        />
      </div>
      <div class="confirm-buttons">
        <button
          class="btn btn_sm bg_danger"
          @click="onConfirm"
        >
          確定
        </button>
        <button
          class="btn btn_sm bg_blue"
          @click="exitInputMode"
        >
          キャンセル
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnetimePaymentCell',
  props: {
    record: {
      type: Object,
      required: true,
    },
    weekIndex: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isInputMode: false,
      isDeleteMode: false,
      inputPriceStr: null,
    };
  },
  computed: {
    displayPrice() {
      return this.record['week' + this.weekIndex] ?? '提供不可';
    },
  },
  methods: {
    enterUpdateMode() {
      this.isInputMode = true;
      this.isDeleteMode = false;
      this.inputPriceStr = this.record['week' + this.weekIndex];
    },
    enterDeleteMode() {
      this.isInputMode = true;
      this.isDeleteMode = true;
      this.inputPriceStr = null;
    },
    exitInputMode() {
      this.isInputMode = false;
      this.isDeleteMode = false;
      this.inputPriceStr = null;
    },
    onConfirm() {
      if (this.isDeleteMode) {
        if (!confirm('対象の日時を提供不可にします。')) return;
        this.$emit('disable', { id: this.record.id, weekIndex: this.weekIndex });
      } else {
        this.$emit('update', { id: this.record.id, weekIndex: this.weekIndex, priceStr: this.inputPriceStr });
      }
      this.exitInputMode();
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  font-size: 16px;
  border-radius: 4px;
  background-color: #00a9ca;
  color: #ffffff;
  padding: 6px 12px;
  cursor: pointer;

  &.btn_sm {
    font-size: 12px;
    padding: 2px 6px;
  }

  &.bg_danger {
    background-color: #d80a0a;
  }
}

.fr {
  float: right;
}

.form-control-sm {
  font-size: 12px;
}

.confirm-buttons {
  margin-top: 4px;
}
</style>
